document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.rte iframe[src*="youtube.com/embed"]').forEach(function (iframe) {
    var match = iframe.src.match(/embed\/([^?&]+)/);
    if (!match) return;

    var videoId = match[1];
    var facade = document.createElement('div');
    facade.className = 'yt-facade';
    facade.style.backgroundImage = 'url(https://img.youtube.com/vi/' + videoId + '/hqdefault.jpg)';
    facade.dataset.src = iframe.src;
    facade.dataset.title = iframe.title || '';
    facade.innerHTML =
      '<button class="yt-facade__play" aria-label="Play video">' +
      '<svg viewBox="0 0 68 48" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M66.52 7.74c-.78-2.93-2.49-5.41-5.42-6.19C55.79.13 34 0 34 0S12.21.13 6.9 1.55c-2.93.78-4.63 3.26-5.42 6.19C.06 13.05 0 24 0 24s.06 10.95 1.48 16.26c.78 2.93 2.49 5.41 5.42 6.19C12.21 47.87 34 48 34 48s21.79-.13 27.1-1.55c2.93-.78 4.64-3.26 5.42-6.19C67.94 34.95 68 24 68 24s-.06-10.95-1.48-16.26z" fill="red"/>' +
      '<path d="M45 24 27 14v20" fill="white"/>' +
      '</svg></button>';

    iframe.parentNode.replaceChild(facade, iframe);

    facade.addEventListener('click', function () {
      var newIframe = document.createElement('iframe');
      var sep = facade.dataset.src.includes('?') ? '&' : '?';
      newIframe.src = facade.dataset.src + sep + 'autoplay=1';
      newIframe.title = facade.dataset.title;
      newIframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
      newIframe.allowFullscreen = true;
      newIframe.style.cssText = 'width:100%;height:100%;border:none;position:absolute;top:0;left:0;';
      facade.replaceWith(newIframe);
    });
  });
});
